ceregoCommon.factory('ItemsResource', ['$resource', ($resource) ->
  $resource "", {},
    get:
      method: 'GET'
      isArray: false
      url: APIRoutes.v2_item_path(":id")
      params:
        id: "@id"
    create:
      method: 'POST'
      isArray: false
      url: APIRoutes.v2_set_items_path(":set_id")
      params:
        set_id: "@set_id"
    update:
      method: 'PUT'
      isArray: false
      url: APIRoutes.v2_item_path(":id")
      params:
        id: "@id"
    query:
      method: 'GET'
      isArray: false
      url: APIRoutes.v2_set_items_path(":set_id")
      params:
        set_id: "@set_id"
    delete:
      method: 'DELETE'
      isArray: false
      url: APIRoutes.v2_set_item_path(":set_id", ":item_id")
      params:
        set_id: "@set_id"
        item_id: "@item_id"
])
